module.exports = __webpack_public_path__ + "img/draw_bonus2.4b48b1dc.png";